export default "__VITE_ASSET__8a9d0cc8__"